import StatusField from "../email/StatusField";
import { REPORT_TYPE } from "../team_experiencer_list/dataset";

const ALREADY_IN_SPORTS = [
    { id: false, name: '同スポーツの団体に所属していない' },
    { id: true, name: '同スポーツの団体に所属している' }
]

const SAME_USER_ID = [
    { id: false, name: '申込み本人ではない' },
    { id: true, name: '申込み本人' }
]
const GENDER = [
    { id: 0, name: '不明' },
    { id: 1, name: '男性' },
    { id: 2, name: '女性' },
    { id: 3, name: '未選択'}

]
export const STATUS = [
    { id: 0, name: '未対応' },
    { id: 1, name: '体験中' },
    { id: 2, name: 'キャンセル' },
    { id: 3, name: '入会' },
    { id: 4, name: '体験終了' },
    { id: 5, name: '辞退' },
    { id: 6, name: '問合せキャンセル' },
    { id: 7, name: '問合せ入会' },
]
export const STATUS_EDIT = [
    { id: 0, name: '未対応' },
    { id: 1, name: '体験中' },
    { id: 2, name: 'キャンセル' },
    { id: 3, name: '入会' },
    { id: 4, name: '体験終了' },
    { id: 5, name: '辞退' }
]
const CONTACT_TYPE = [
    { id: 2, name: '体験申込み' },
    { id: 3, name: '入会申込み' }, 
    { id: 4, name: '見学申し込み'}, 
]
const DATA = [
    { name: 'id', type: 'textinput', searchField: '', options:[], reference: '', nullable: true, editable: false, export: true, import: true },
    { name: 'team_contact_id', type: 'reference',reference: 'team_contact', searchField: 'name', nullable: false, editable: false, export: false, import: true },
    { name: 'created_by_email', type: 'hidden',  export: false },
    { name: 'created_by_phone', type: 'hidden',  export: false },
    { name: 'team_contact_name', type: 'team_contact_name',reference: 'team_contact', searchField: 'name', nullable: false, editable: false, export: false, import: true },
    { name: 'account_name',type: 'account_name',  export: true },
    { name: 'account_name_history', type: 'textinput', nullable: false, editable: true, export: true, import: true },
    { name: 'team_name', type: 'textinput',  export: true },
    { name: 'lastname', type: 'textinput', nullable: false, editable: true, export: true, import: true },
    { name: 'firstname', type: 'textinput', nullable: false, editable: true, export: true, import: true },
    { name: 'user_name',  type: 'hidden', export: true },
    { name: 'user_phone', type: 'hidden',  export: true },
    { name: 'user_email', type: 'hidden',  export: true },
    { name: 'account_email', type: 'hidden',  export: false },
    { name: 'account_phone', type: 'hidden',  export: false },

    { name: 'team_contact_id', type: 'deepReference',reference: 'team_contact', searchField: 'name', nullable: false, editable: false, export: false, import: false },
    { name: 'team_name', type: 'deepReference',reference: 'team_contact', searchField: 'name', nullable: false, editable: false, export: false, import: false },
    { name: 'same_user_id', type: 'status',options: SAME_USER_ID, nullable: false, editable: true, export: true, import: true },
    //{ name: 'team_contact_id', type: 'contact_type',reference: 'team_contact', searchField: 'contact_type', nullable: false, editable: false, export: false, import: false },
    { name: 'contact_type', type: 'contact_type', options: CONTACT_TYPE, nullable: false, editable: false, export: true, import: true },
    { name: 'account_source', type: 'account_source', searchField: 'source', nullable: false, editable: false, export: true, import: false },
    { name: 'status', type: 'status', options:STATUS_EDIT, nullable: false, editable: true, export: true, import: true },
    { name: 'status_updated_at', type: 'date',nullable: false, editable: true, export: true, import: true },
    { name: 'lastname_kana', type: 'textinput', nullable: false, editable: true, export: true, import: true },
    { name: 'firstname_kana', type: 'textinput', nullable: false, editable: true, export: true, import: true },
    
    { name: 'gender', type: 'status',options: GENDER, nullable: false, editable: true, export: true, import: true },
    { name: 'birthday', type: 'date', nullable: false, editable: false,  export: true, import: true },
    { name: 'age', type: 'age',  export: true},
    { name: 'amount', type: 'textinput',numberFormat: true, nullable: true, editable: true, export: true, import: true },
    { name: 'team_contact_id', type: 'fee',reference: 'team_contact', searchField: 'monthly_fee', nullable: false, editable: false, export: false, import: true },
    { name: 'team_contact_id', type: 'monthly_fee',reference: 'team_contact', searchField: 'name', nullable: false, editable: false, export: false, import: true },
    { name: 'report_admin_approve_status', type: 'status',options: REPORT_TYPE, nullable: false, editable: true, export: true, import: true },

    { name: 'report_admin_decline_reason', type: 'textinput', multiline: true, nullable: true, editable: true, export: true },

    { name: 'already_in_sports', type: 'status',options: ALREADY_IN_SPORTS, nullable: false, editable: true, export: true, import: true },
    { name: 'created', type: 'date', nullable: false, editable: true, export: true, import: true },
    { name: 'created_by', type: 'textinput', nullable: false, editable: false, export: true, import: true },
    { name: 'user_comment', type: 'textinput',multiline:true, nullable: true, editable: true, export: true },
    { name: 'note', type: 'textinput',multiline: true, nullable: true, editable: true, export: true, import: true },
]

export default DATA;